import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import Button from '@mui/material/Button';
import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {BrickContext} from 'olympe';
import {TablePaginationWithPageSelector} from '../../TablePaginationWithPageSelector.jsx';
import {changeTabLambda} from '../../../utils/functionSignatures';
import AppController from '../../../controllers/AppController';
import {LAMBDA_NAMES} from '../../../utils/constants';

/**
 * This component display a popup with the list of mass copied PRs.
 * @param {MassCopySuccessPopup.propTypes} props
 * @return {JSX.Element}
 */
export function MassCopySuccessPopup(props) {
    const multiplePRs = props.prs.length > 1;

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [pageNum, setPageNum] = useState([]);
    const pageSize = rowsPerPage === -1 ? props.prs.length : (props.prs.length) / rowsPerPage;

    const changeTab = props.context.get(LAMBDA_NAMES.CHANGE_TAB);

    const handlePageSelection = (newValue) => {
        setPage(newValue);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    useEffect(() => {
        const temp = [];
        if (rowsPerPage === -1) {
            temp.push(
                {
                    label: `1-${props.prs.length}`,
                    value: 1,
                },
            );
        } else {
            for (let i = 0; i < pageSize; i++) {
                temp.push({
                    label: `${(i * rowsPerPage) + 1}-${(i + 1) * rowsPerPage < props.prs.length ? (i + 1) * rowsPerPage : props.prs.length}`,
                    value: i + 1,
                });
            }
        }
        return setPageNum(temp);
    }, [pageSize]);

    const paginatedPRs = props.prs.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const handleCancel = () => {
        props.context.set('Failed PRs', props.failedMassSubmittedPRs);
        changeTabLambda(props.context, changeTab, 'open requests', '', () => {});
        AppController.refreshPRsList();
        props.setOpen(false);
    };

    return (
        <Dialog
            onClose={handleCancel}
            open={props.open}
            aria-labelledby="mass-copy-popup"
            sx={{
                '& .MuiDialog-paper': {
                    width: '45%',
                    maxWidth: 'none',
                },
            }}
        >
            <div style={{display: 'flex'}}>
                <div style={{backgroundColor: '#008000', width: '20%', height: 'auto', display: 'flex', alignItems: 'center', minWidth: '50px', maxWidth: '70px', justifyContent: 'center'}}>
                    <i className="material-icons" style={{color: 'white'}}>{'check_circle'}</i>
                </div>
                <div style={{flexGrow: 1, padding: '16px'}}>
                    <DialogTitle id="popup-title">
                        {multiplePRs ? 'Multiple requests have been copied' : 'Your request has been copied'}
                    </DialogTitle>

                    <DialogContent className='popup-scroller'
                        sx={{
                            maxHeight: '400px !important',
                            overflowY: 'scroll !important',
                            minWidth: '30rem',
                        }}>

                        {props.prs.length > 0 && (
                            <>
                                <DialogContentText sx={{color: 'black'}}>
                                    {multiplePRs ? 'These are the new requests created:' : 'This is the new request created:'}
                                </DialogContentText>
                                <ul>
                                    {paginatedPRs.map((pr, idx) => (
                                        <li key={`${pr.EPRID}`}>
                                            <DialogContentText id="list-of-copied-prs">
                                                {`New EPR-${pr.EPRID} copied from EPR-${pr.originalEPRID}`}
                                            </DialogContentText>
                                        </li>
                                    ))}
                                </ul>
                                <div style={{marginBottom: '5rem'}}>
                                    <TablePaginationWithPageSelector
                                        page={page}
                                        pageNum={pageNum}
                                        rowsPerPage={rowsPerPage}
                                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                                        handleChangePage={handleChangePage}
                                        handlePageSelection={handlePageSelection}
                                        count={props.prs.length}
                                        rowsPerPageOptions={[2, 5, 10, 20, 50, 100, 200]}
                                        textColor="rgba(0, 0, 0, 0.6)"
                                    />
                                </div>
                            </>
                        )}
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleCancel}>Ok</Button>
                    </DialogActions>
                </div>
            </div>
        </Dialog>
    );
}

MassCopySuccessPopup.propTypes = {
    context: PropTypes.instanceOf(BrickContext).isRequired,
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    prs: PropTypes.arrayOf(PropTypes.object),
    failedMassSubmittedPRs: PropTypes.array.isRequired,
};
